//========== Preloader Section Component ==========

import "./preloader.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const Preloader = () => {
  return /*#__PURE__*/_jsx("div", {
    className: "preloader",
    children: /*#__PURE__*/_jsx("div", {
      className: "preloader-container",
      children: /*#__PURE__*/_jsx("span", {
        className: "animated-preloader"
      })
    })
  });
};
export default Preloader;